module.exports = __webpack_public_path__ + "static/fppm-e-logo-81cb280ada0a9af252e130f898bbca97.jpeg";